<template>
  <svg
    viewBox="0 0 157 60"
    class="luce-wordmark"
    role="img"
    :aria-label="label"
  >
    <defs v-if="source">
      <radialGradient
        :id="gradientId"
        cx="38%"
        cy="34%"
        r="72%"
      >
        <stop
          offset="0%"
          stop-color="#ffffff"
        />
        <stop
          offset="30%"
          stop-color="#9ff0e4"
        />
        <stop
          offset="100%"
          stop-color="#3fb0a8"
        />
      </radialGradient>
    </defs>

    <g fill="currentColor">
      <path d="M 31.0 5.4 L 29.5 4.6 L 29.0 4.7 L 28.5 5.3 L 26.0 9.0 L 23.6 12.8 L 21.4 16.8 L 19.4 20.9 L 17.3 26.6 L 15.8 32.3 L 15.1 37.5 L 15.2 39.3 L 15.5 40.9 L 16.7 43.2 L 18.6 45.0 L 19.7 46.4 L 21.3 47.5 L 23.2 48.2 L 26.2 48.7 L 43.6 48.7 L 43.8 48.3 L 43.9 47.0 L 43.9 45.0 L 43.8 43.7 L 43.6 43.3 L 23.5 43.4 L 21.0 43.1 L 20.6 42.9 L 20.4 42.5 L 20.3 40.4 L 21.0 35.7 L 21.8 32.5 L 22.9 28.9 L 24.9 23.8 L 27.5 18.7 L 30.6 13.4 L 34.1 8.5 L 34.0 8.0 L 32.8 6.9 Z" />
      <path d="M 49.9 25.7 L 48.4 25.2 L 48.0 25.3 L 46.5 29.1 L 45.4 32.7 L 44.7 36.0 L 44.5 38.7 L 44.7 41.5 L 45.6 43.9 L 46.1 44.7 L 47.7 45.9 L 48.6 47.2 L 49.6 48.0 L 50.9 48.6 L 52.3 48.8 L 53.9 48.7 L 55.5 48.2 L 57.0 47.4 L 58.4 46.3 L 59.8 45.0 L 61.3 43.3 L 63.0 40.5 L 67.1 32.4 L 69.1 29.5 L 66.9 28.9 L 64.7 27.8 L 64.0 32.3 L 61.8 42.9 L 62.1 44.1 L 62.8 45.1 L 64.2 46.1 L 65.0 47.3 L 66.1 48.1 L 67.6 48.6 L 69.4 48.5 L 71.6 47.7 L 73.6 46.4 L 75.4 44.6 L 77.3 42.2 L 77.1 41.8 L 75.9 40.8 L 74.0 39.4 L 72.6 38.6 L 72.1 38.6 L 69.9 41.1 L 67.4 43.0 L 66.7 43.9 L 66.2 44.0 L 66.4 43.4 L 67.2 44.0 L 67.4 43.9 L 69.5 34.1 L 69.9 31.6 L 69.9 29.5 L 69.7 27.8 L 69.2 26.6 L 68.5 26.0 L 67.1 25.3 L 65.5 24.9 L 64.3 25.2 L 62.9 27.1 L 61.3 29.9 L 57.7 37.0 L 56.0 39.7 L 54.6 41.2 L 53.2 42.3 L 50.8 43.8 L 49.8 43.9 L 49.6 43.3 L 49.8 40.5 L 50.4 36.9 L 51.7 32.7 L 53.6 27.7 L 53.4 27.3 L 52.0 26.6 Z" />
      <path d="M 93.6 29.6 L 94.4 29.1 L 94.5 28.8 L 93.0 27.6 L 91.5 25.9 L 89.6 24.8 L 87.4 24.4 L 85.0 24.6 L 82.7 25.5 L 80.5 27.0 L 78.5 29.0 L 77.1 31.2 L 76.0 33.9 L 75.5 36.6 L 75.6 39.0 L 76.0 40.9 L 76.9 42.5 L 80.7 46.5 L 82.1 47.2 L 84.6 47.9 L 86.5 47.9 L 88.5 47.5 L 90.5 46.6 L 92.5 45.2 L 94.4 43.5 L 96.3 41.2 L 94.9 39.8 L 93.0 38.3 L 91.3 37.3 L 88.5 40.2 L 85.7 42.0 L 83.7 42.7 L 81.5 42.6 L 80.9 42.3 L 80.7 39.8 L 81.3 37.0 L 82.4 34.6 L 84.0 32.4 L 86.1 30.7 L 88.6 29.6 L 89.9 29.5 L 90.9 29.6 L 91.2 30.7 L 92.3 30.3 Z" />
      <path d="M 97.1 43.0 L 97.2 44.3 L 97.4 44.7 L 97.7 44.7 L 101.9 44.6 L 106.3 43.7 L 109.2 42.5 L 111.8 40.9 L 114.2 39.0 L 115.8 36.9 L 116.8 35.1 L 117.3 33.2 L 117.3 31.3 L 116.7 29.6 L 115.8 28.5 L 114.6 27.5 L 113.6 26.3 L 112.6 25.5 L 110.8 24.7 L 108.9 24.6 L 107.7 24.8 L 106.4 25.3 L 104.0 26.9 L 101.6 29.7 L 99.8 33.1 L 98.9 36.4 L 98.7 39.5 L 99.3 42.3 L 99.9 43.6 L 100.7 44.6 L 101.9 45.6 L 103.5 47.3 L 105.4 48.4 L 108.3 49.1 L 111.6 48.9 L 115.2 48.0 L 118.4 46.4 L 121.4 44.0 L 123.9 41.1 L 122.4 39.7 L 118.9 37.2 L 117.4 39.0 L 115.7 40.5 L 114.1 41.6 L 112.1 42.7 L 110.0 43.4 L 107.7 43.8 L 105.4 43.8 L 104.0 43.5 L 103.9 41.2 L 104.2 39.1 L 104.9 36.9 L 105.9 34.7 L 107.3 32.8 L 108.9 31.1 L 110.8 29.9 L 112.2 29.5 L 112.5 29.6 L 112.5 30.2 L 111.8 31.7 L 110.2 33.9 L 108.3 35.7 L 106.0 37.2 L 103.4 38.3 L 100.6 39.0 L 97.6 39.4 L 97.4 39.7 L 97.2 41.0 Z" />
    </g>

    <template v-if="source">
      <circle
        cx="133"
        cy="20"
        r="8"
        fill="#6ed6ce"
        opacity="0.35"
      />
      <circle
        cx="133"
        cy="20"
        r="5.5"
        :fill="`url(#${gradientId})`"
      />
    </template>
  </svg>
</template>

<script setup>
import { useId } from 'vue';

/**
 * La signature de Luce, écrite à la plume.
 *
 * L'encre suit `currentColor` : marine sur fond clair, clair sur le marine,
 * sans avoir à basculer de fichier. Passer `source` à false donne la version
 * monochrome, celle qui part à l'impression.
 */

defineProps({
    source: {
        type: Boolean,
        default: true,
    },
    label: {
        type: String,
        default: 'Luce',
    },
});

const gradientId = `luce-wm-${useId()}`;
</script>

<style scoped>
.luce-wordmark {
  display: block;
  width: auto;
  height: 100%;
}
</style>
